import React from 'react';

export default function Footer() {
	return (
		<div className="footer">
			<div className="footer--wrapper">
				<span>Made by <a href="https://github.com/a-khoirunnufus">Ahmad Khoirunnufus</a> | </span>
				<span>Powered by <a href="https://www.weatherapi.com/" title="Free Weather API">WeatherAPI.com</a></span>
			</div>
		</div>
	);
}